<template>
    <div>
      <div :style="'z-index: 0;position: relative;height:211px;color#fff;padding:15px;background-image: linear-gradient(0deg,' + $bgColor + '0%,' + $bgColor2 + '100%);'">
        <!-- <div :style="'height: 143px;background-color:' + $bgColor2 + ';width: 143px;border-radius: 100px;position: absolute;z-index: -1;right: 14px;top: -52px;'"></div>
        <div :style="'height: 90px;background-color:' + $bgColor2 + ';width: 45px;border-top-left-radius: 110px;border-bottom-left-radius: 110px;position: absolute;z-index: -1;right: 1px;top: 29px;'"></div>
        <div :style="'height: 89px;background-color:' + $bgColor3 + ';width: 89px;border-radius: 100px;position: absolute;z-index: -1;right: 17px;top: 58px;'"></div> -->
        <v-row>
          <strong style="color:#fff;font-size: 20px;padding:15px;">สัญญาส่งอ้อย</strong>
          <div style="align-items: center;display: flex;"> <img
            v-if="profile.pictureUrl"
            style="
            border-color: white;
            height: 40px;
            "
            alt="Avatar"
            :src="require('@/assets/contract.png')"
            /></div>
        </v-row>
        <div class="mt-6" style="display:flex">
            <div class="mr-4">
                <v-avatar
                size="100"
                tile>
                <img
                    :src="member.LinePicture"
                    alt="John"
                >
                </v-avatar>
            </div>
            <v-card style="color:black;border-radius: 15px;width: 100%;padding-left:10px;padding-top: 10px;background-color: snow;" elevation="5">
                <div>เลขโควต้า: {{myContract.quotaNumber}}</div>
                <div>ชื่อ: {{this.member.nameCustomer}}</div>
                <div class="mb-0">เบอร์โทรศัพท์: {{this.member.tel}}</div>
            </v-card>
        </div>
          <!-- <v-row justify="center" class="mt-3 pt-2">
            <v-col cols="4" align="center" class="pa-2" style="font-size:15px;background-color:#ffff;box-shadow: 0px 1px 1px 0px #00000040;border-top-left-radius: 15px;border-bottom-left-radius: 15px;">
              {{ $t("message.allPackage") }}
            <v-col align="center" class="pa-0" :style="'font-weight: bold;font-size:20px;color:' + $bgColor" v-if="myPackage.length > 0">{{myPackage.length}}</v-col>
            <v-col align="center" class="pa-0" :style="'font-weight: bold;font-size:20px;color:' + $bgColor" v-if="myPackage.length <= 0">0</v-col>
          </v-col>
           <v-col cols="4" align="center" class="pa-2" style="font-size:15px;background-color:#ffff;box-shadow: 0px 1px 1px 0px #00000040;border-top-right-radius: 15px;border-bottom-right-radius: 15px;">
            {{ $t("message.availablePackages") }}
            <v-col align="center" :style="'font-weight: bold;font-size:20px;color:' + $bgColor" class="pa-0">{{myPackage.filter(a => a.expirePackage * 1000 > today.getTime()).filter(a => a.balanceAmount > 0 ).length}}</v-col>
          </v-col>
          </v-row> -->
      </div>
      <div class="pa-5">
        <div class="cardja">
            <h5><v-icon>mdi-file-account</v-icon>สัญญาของคุณ</h5>
            <v-divider></v-divider>
            <div class="mb-6"><v-icon class="mr-2">mdi-file-document-edit-outline</v-icon>สัญญาส่งอ้อย: {{myContract.contract.split('.')[0]}} ตัน</div>
            <div class="mb-4">
                <p class="mb-0"> <v-icon class="mr-2 pb-1">mdi-palm-tree </v-icon>ส่งอ้อยจริง: {{myContract.sendSugarCane}} ตัน</p>
                <p>เปอร์เซนส่งอ้อยจริง: {{myContract.percentSendSugarCane}}% </p>
                <!-- <p>ขาดอีก: 100 </p> -->
                <v-progress-linear
                    class="mt-2"
                    color="deep-purple accent-4"
                    rounded
                    :value="myContract.percentSendSugarCane"
                    height="6"
                ></v-progress-linear>
            </div>
        </div>
      </div>
    </div>
  </template>
<script>
import { mapGetters } from 'vuex'
// import Qrcode from './Qrcode'
// import axios from 'axios'
// import moment from 'moment'
export default {
  name: 'AllRewards',
  components: {
    // 'qrcode-usecode': Qrcode
  },
  data () {
    return {
      myContract: null,
      myPackageTransaxtion: null,
      member: null,
      profile: null,
      use: null,
      dialog: false,
      liffID: null,
      today: new Date(),
      tab: null,
      shopId: null,
      dataLineConfig: [],
      liff: 'https://liff.line.me/',
      typeBelinked: null,
      selected: '',
      columns2: [
        { text: 'ชื่อแพ็กเกจ', value: 'packageName' },
        { text: 'จำนวน', value: 'balanceAmount' },
        // { text: 'สาขา', value: 'balanceAmount' },
        { text: 'คะแนนที่ได้', value: 'packagePoint' },
        { text: 'เวลาที่ใช้', value: 'CREATE_DATE' }
      ]
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    window.scrollTo(0, 0)
    this.member = this.GET_MEMBERINFO()
    this.profile = this.getLiffProfile()
    this.shopId = this.GET_SHOPID()

    await this.getDatalin()
    // await this.getPackageTransaction()
    // console.log(new Date().getTime())
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),
    ...mapGetters('shopStore', ['GET_SHOPID']),

    async getDatalin () {
      try {
        // alert(this.member)
        const result = await this.callBeTaskAPI(
          'get',
          `/get-lindata?quotaNumber=${this.member.barcodeNum}`
        )
        if (Array.isArray(result)) {
          this.myContract = result[0]
        } else {
          this.myPackage = []
        }
      } catch (error) {
        // alert(error)
      }
    }
    // arrayMove (arr, oldindex, newindex) {
    //   // arr.splice(newindex, 0, arr.splice(oldindex, 1)[0])
    //   return moment.unix(arr).format('DD/MM/YYYY')
    // },
    // async getPackage () {
    //   const result = await this.callBeTaskAPI(
    //     'get',
    //     `/PackageLog/getBystatus?memberId=${this.profile.memberId}&shopId=${this.shopId}`
    //   )
    //   if (Array.isArray(result)) {
    //     this.myPackage = result
    //     console.log('getPackage', result)
    //   } else {
    //     this.myPackage = []
    //   }
    //   console.log()
    // },
    // async getPackageTransaction () {
    //   const result = await this.callBeTaskAPI(
    //     'get',
    //     `/PackageTransaction/get?memberId=${this.profile.memberId}&shopId=${this.shopId}`
    //   )
    //   if (Array.isArray(result)) {
    //     this.myPackageTransaxtion = result
    //     console.log('PackageTransaction', this.myPackageTransaxtion)
    //   }
    //   // console.log(new Date(this.momenDate_1(result[0].endDate)).getTime())
    // },
    // useReward (item) {
    //   this.use = item
    //   this.dialog = true
    // },
    // closeUseReward () {
    //   this.myPackage = null
    //   this.getPackage()
    //   this.dialog = false
    // },
    // async pushToBelinked (item) {
    //   console.log('checkPushToBelinked', this.WEB_BELINK)
    //   await this.checktypeBelink()
    //   console.log(item)
    //   if (process.env.NODE_ENV === 'development') {
    //     window.location.href = this.WEB_BELINK + this.typeBelinked + `?shopId=` + this.shopId + '&flowId=' + item.flowId + '&packageId=' + item.packageId + '&branchId=' + item.branchId + '&tokenPackage=' + item.token + '&packageName=' + item.packageName + '&source=loyalty'
    //   } else {
    //     window.location.href = this.WEB_BELINK + this.liffID + `?shopId=` + this.shopId + '&flowId=' + item.flowId + '&packageId=' + item.packageId + '&branchId=' + item.branchId + '&tokenPackage=' + item.token + '&packageName=' + item.packageName + '&source=loyalty'
    //   }
    // },
    // async checktypeBelink () {
    //   try {
    //     await this.getDataLineConfig(this.shopId)
    //     console.log('dataLineConfig', this.dataLineConfig)
    //     const result = await axios.get(this.DNS_Link + `/sys_shop/get?shopId=${this.shopId}`)
    //     console.log('result.data[0].timeSlotStatus', result.data[0].timeSlotStatus)
    //     if (result.data[0].timeSlotStatus === 'True') {
    //       this.typeBelinked = '/BookingFormEmp'
    //       this.liffID = this.dataLineConfig.liffBookingFormEmpID
    //     } else {
    //       this.typeBelinked = '/BookingForm'
    //       this.liffID = this.dataLineConfig.liffBookingFormID
    //     }
    //     console.log('liffID', this.liffID)
    //   } catch (error) {
    //     console.log(error)
    //   }
    // },
    // async getDataLineConfig (shopId) {
    //   this.dataLineConfig = []
    //   await axios.get(this.DNS_Link + '/lineconfig/get?shopId=' + shopId).then(response => {
    //     let rs = response.data
    //     console.log('getDataLineConfig shopId', shopId)
    //     console.log('getDataLineConfig', rs)
    //     if (rs.status === false) {
    //       this.dataLineConfig = {
    //         liffMainID: '1656581804-7KRQyqo5',
    //         liffBookingFormID: '1656581804-32mk7OgE',
    //         liffBookingFormEmpID: '1656581804-b09WBwkP',
    //         checkConfig: false
    //       }
    //     } else {
    //       this.dataLineConfig = rs[0]
    //     }
    //   }).catch((error) => {
    //     console.log(error)
    //     this.dataLineConfig = {
    //       liffMainID: '1656581804-7KRQyqo5',
    //       liffBookingFormID: '1656581804-32mk7OgE',
    //       liffBookingFormEmpID: '1656581804-b09WBwkP',
    //       checkConfig: false
    //     }
    //   })
    // }
  }
}
</script>
<style scoped>
.cardja {
  width: 100%;
  min-height: 257px;
  padding: 20px;
  background: rgb(246 246 246);;
  box-shadow: rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/LinCheckContract.vue